import { useQuery } from '@tanstack/react-query';
import { FeaturesApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useFeaturesQueryControllerGetFeatureByIdQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['featuresQueryControllerGetFeatureById', accessControlScope, args],
        queryFn: async () => {
            const api = new FeaturesApi(accessControlConfig);
            return api.featuresQueryControllerGetFeatureById(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useFeaturesQueryControllerGetFeatureByIdQuery.js.map